import { Capacitor } from '@capacitor/core';
import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';
import { postApi } from './api';

const IOS_PRODUCT_ID = 'com.miiq.fitfinder.premium';
const REVENUECAT_IOS_KEY = 'appl_tnPpvDtSknZdXjtUeGsRVdONFHF';

let revenueCatConfigured = false;

const configureRevenueCat = async () => {
  if (revenueCatConfigured) return;
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') {
    await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
    await Purchases.configure({ apiKey: REVENUECAT_IOS_KEY });
    revenueCatConfigured = true;
  }
};

export const initPayments = async () => {
  const platform = Capacitor.getPlatform();
  console.log('Platform detected:', platform);
  if (platform === 'ios') {
    await configureRevenueCat();
  }
};

export const handlePurchase = async (userEmail, userName) => {
  const platform = Capacitor.getPlatform();

  if (platform === 'ios') {
    try {
      await configureRevenueCat();
      const offerings = await Purchases.getOfferings();
      if (!offerings.current) throw new Error('No offerings available');
      const pkg = offerings.current.lifetime ||
                  offerings.current.availablePackages.find(p => p.packageType === 'LIFETIME') ||
                  offerings.current.availablePackages[0];
      if (!pkg) throw new Error('No package available');
      const { customerInfo } = await Purchases.purchasePackage({ aPackage: pkg });
      console.log('RC active entitlements:', JSON.stringify(Object.keys(customerInfo.entitlements.active)));
      console.log('RC all entitlements:', JSON.stringify(Object.keys(customerInfo.entitlements.all)));
      const isPremium = Object.keys(customerInfo.entitlements.active).length > 0;
      return { success: isPremium, platform: 'ios' };
    } catch (err) {
      const isCancel =
        err?.code === 'PURCHASE_CANCELLED' ||
        err?.userCancelled === true ||
        err?.code === '1' ||
        /cancel/i.test(err?.message || '');
      if (isCancel) {
        return { success: false, cancelled: true, platform: 'ios' };
      }
      throw err;
    }
  } else {
    const data = await postApi('/api/create-checkout-session', { email: userEmail, name: userName });
    if (!data?.url) throw new Error('No checkout URL received');
    window.location.href = data.url;
    return { success: false, redirecting: true };
  }
};

export const checkPremiumStatus = async () => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') {
    try {
      await configureRevenueCat();
      const { customerInfo } = await Purchases.getCustomerInfo();
      return Object.keys(customerInfo.entitlements.active).length > 0;
    } catch {
      return false;
    }
  }
  return null;
};

export const restorePurchases = async () => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') {
    try {
      await configureRevenueCat();
      const { customerInfo } = await Purchases.restorePurchases();
      return Object.keys(customerInfo.entitlements.active).length > 0;
    } catch {
      return false;
    }
  }
  return false;
};

// RevenueCat app user id, sent to /api/ios-entitlement so the server can verify the purchase.
export const getIOSAppUserId = async () => {
  if (Capacitor.getPlatform() !== 'ios') return null;
  try {
    await configureRevenueCat();
    const { appUserID } = await Purchases.getAppUserID();
    return appUserID || null;
  } catch {
    return null;
  }
};
